<script>
export default {
  name: 'LoginFormFooterTermAndCondition',
}
</script>

<template>
  <div class="tamara-login-form-footer-term-and-condition">
    {{ $t('i_accept') }}
    <el-link
      target="_blank"
      :href="$t('terms_and_conditions_url')"
      class="tamara-login-form-footer-term-and-condition__link"
    >
      {{ $t('terms_and_conditions') }}
    </el-link>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-login-form-footer-term-and-condition {
  @extend .tamara-label-small;

  display: flex;
  gap: 4px;
  align-items: flex-end;
  color: var(--tamara-color-text-secondary);

  &__link {
    color: var(--tamara-color-link);

    @extend .tamara-label-small;
  }
}
</style>
